import { post, put } from './requests'

const resourcePath = 'invites'

export function createInvite (invite) {
  return post(resourcePath, { invite })
}

export function updateInvite (invite) {
  return put(`${resourcePath}/${invite.id}`, { invite })
}

export function resendInvite (id) {
  return post(`${resourcePath}/${id}/resend`)
}
